import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CategoryProductGrid from './CategoryProductGrid';
import Cart from './Cart';
import CheckoutForm from './CheckoutForm';
import './CustomerApp.css';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_test_placeholder');

function CustomerApp({ 
  cart: propCart, 
  setCart: propSetCart, 
  showCart: propShowCart, 
  setShowCart: propSetShowCart,
  addToCart: propAddToCart,
  removeFromCart: propRemoveFromCart,
  updateQuantity: propUpdateQuantity,
  getCartTotal: propGetCartTotal
}) {
  const [products, setProducts] = useState([]);
  const [internalCart, setInternalCart] = useState([]);
  const [internalShowCart, setInternalShowCart] = useState(false);
  
  const cart = propCart !== undefined ? propCart : internalCart;
  const setCart = propSetCart !== undefined ? propSetCart : setInternalCart;
  const showCart = propShowCart !== undefined ? propShowCart : internalShowCart;
  const setShowCart = propSetShowCart !== undefined ? propSetShowCart : setInternalShowCart;
  
  const addToCart = propAddToCart !== undefined ? propAddToCart : ((product) => {
    const existingItem = cart.find(item => item.id === product.id);
    
    if (existingItem) {
      setCart(cart.map(item =>
        item.id === product.id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  });
  
  const removeFromCart = propRemoveFromCart !== undefined ? propRemoveFromCart : ((productId) => {
    setCart(cart.filter(item => item.id !== productId));
  });
  
  const updateQuantity = propUpdateQuantity !== undefined ? propUpdateQuantity : ((productId, quantity) => {
    if (quantity <= 0) {
      removeFromCart(productId);
    } else {
      setCart(cart.map(item =>
        item.id === productId ? { ...item, quantity } : item
      ));
    }
  });
  
  const getCartTotal = propGetCartTotal !== undefined ? propGetCartTotal : (() => {
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  });
  const [showCheckout, setShowCheckout] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [loading, setLoading] = useState(true);

  const categories = [
    'All',
    'Accessories',
    'Bags',
    'Flags',
    'Hats',
    'Hoodies',
    'Jackets',
    'Mugs',
    'Skully',
    'Sleeves',
    'Sweat Suits',
    'Totes',
    'Towels',
    'T-Shirts'
  ];

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      const productsSnapshot = await getDocs(collection(db, 'products'));
      const productsData = productsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setProducts(productsData);
    } catch (error) {
      console.error('Error loading products:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredProducts = selectedCategory === 'All'
    ? products
    : products.filter(p => p.category === selectedCategory);

  return (
    <div className="customer-app">
      <main className="main-content">
        <div className="container">
          {loading ? (
            <div className="loading-container">
              <div className="spinner"></div>
              <p>Loading products...</p>
            </div>
          ) : (
            <CategoryProductGrid 
              products={products}
              onAddToCart={addToCart}
            />
          )}
        </div>
      </main>
    </div>
  );
}

export default CustomerApp;
